module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_03-24a72830f72b6abfe4404129e9d187ac.webp";